import React, { useEffect, useState } from "react";
import { toJalaali, toGregorian, jalaaliMonthLength } from "jalaali-js";
import { normIso } from "../core/format";

const MONTHS = ["فروردین","اردیبهشت","خرداد","تیر","مرداد","شهریور","مهر","آبان","آذر","دی","بهمن","اسفند"];
const EMPTY = { y: "", m: "", d: "" };
const fa = (n) => Number(n).toLocaleString("fa-IR", { useGrouping: false });
const selStyle = {
  flex: 1, padding: "13px 10px", background: "var(--card-2)", color: "var(--ink)",
  border: "1.5px solid var(--border)", borderRadius: "var(--radius-sm)", fontFamily: "inherit",
};

export const isoToParts = (iso) => {
  if (!iso) return EMPTY;
  const [gy, gm, gd] = normIso(iso).split("-").map(Number);
  const j = toJalaali(gy, gm, gd);
  return { y: String(j.jy), m: String(j.jm), d: String(j.jd) };
};

export const partsToIso = ({ y, m, d }) => {
  if (!y || !m || !d) return "";
  const g = toGregorian(+y, +m, +d);
  const p = (n) => String(n).padStart(2, "0");
  return `${g.gy}-${p(g.gm)}-${p(g.gd)}`;
};

export const formatJalali = (iso) => {
  if (!iso) return "—";
  const p = isoToParts(iso);
  return `${fa(p.y)}/${fa(p.m)}/${fa(p.d)}`;
};

export const currentJalali = () => {
  const n = new Date();
  return toJalaali(n.getFullYear(), n.getMonth() + 1, n.getDate());
};

export default function JalaliDate({ label, value, onChange, disabled, error, minYear, maxYear }) {
  const now = currentJalali().jy;
  const lo = minYear ?? now - 1;
  const hi = maxYear ?? now + 4;
  const [p, setP] = useState(() => isoToParts(value));

  useEffect(() => {
    if (value) setP(isoToParts(value));
  }, [value]);

  const days = p.y && p.m ? jalaaliMonthLength(+p.y, +p.m) : 31;
  const set = (k, v) => {
    const next = { ...p, [k]: v };
    if (next.y && next.m && next.d && +next.d > jalaaliMonthLength(+next.y, +next.m)) next.d = "";
    setP(next);
    onChange(partsToIso(next));
  };

  return (
    <div className="field">
      <label>{label}</label>
      <div style={{ display: "flex", gap: 8 }}>
        <select style={selStyle} value={p.d} disabled={disabled} onChange={(e) => set("d", e.target.value)}>
          <option value="">روز</option>
          {Array.from({ length: days }, (_, i) => i + 1).map((n) => (
            <option key={n} value={n}>{fa(n)}</option>
          ))}
        </select>
        <select style={selStyle} value={p.m} disabled={disabled} onChange={(e) => set("m", e.target.value)}>
          <option value="">ماه</option>
          {MONTHS.map((n, i) => <option key={n} value={i + 1}>{n}</option>)}
        </select>
        <select style={selStyle} value={p.y} disabled={disabled} onChange={(e) => set("y", e.target.value)}>
          <option value="">سال</option>
          {Array.from({ length: hi - lo + 1 }, (_, i) => hi - i).map((n) => (
            <option key={n} value={n}>{fa(n)}</option>
          ))}
        </select>
      </div>
      {error && <small className="cm-err">{error}</small>}
    </div>
  );
}
